const commonAndMisc = {
  errorMessage404: "Oups ! La page que vous recherchez n'existe pas", // translated
  backToHome: "De retour à la maison", // translated
  information: "Information", // translated
  additionalInformation: "Informations Complémentaires", // translated
  destinationPlaceholder: "Où vas-tu", // translated
  aboutUs: "À propos de nous", // translated
  pleaseWait: "S'il vous plaît, attendez...", // translated
  featuredHotels: "Hôtels en vedette", // translated
  topPackages: "Meilleurs forfaits", // translated
  topTours: "Meilleures visites", // translated
  traveller: "Voyageur", // translated
  reviews: "Commentaires", // translated
  home: "Domicile", // translated
  packages: "Paquets", // translated
  experiences: "Expériences", // translated
  close: "proche", // translated
  loadingMessage: "Veuillez patienter pendant que nous recherchons les meilleurs prix disponibles", // translated
  loadingMessageTheHotelCo: "Veuillez patienter pendant que nous recherchons les meilleurs prix disponibles", // translated
  loadingMessageSearchStrip: "Veuillez patienter pendant que nous recherchons les meilleurs prix disponibles...", // translated
  topCountriesToVisit: "Principaux pays à visiter", // translated
  profile: "Profil", // translated
  reservations: "Réservations", // translated
  address: "Adresse", // translated
  firstName: "Prénom", // translated
  lastName: "Nom de famille", // translated
  email: "E-mail", // translated
  login: "Connexion", // translated
  logout: "Se déconnecter", // translated
  myProfile: "Mon profil", // translated
  verified: "Vérifié", // translated
  unverified: "Non vérifié", // translated
  selectLanguage: "Choisir la langue", // translated
  selectCurrency: "Sélectionnez la devise", // translated
  upgrade: "Améliorer", // translated
  membership: "Adhésion", // translated
  travelTrust: "Fiducie de voyage", // translated
  signInUp: "Se connecter/s'inscrire", // translated
  worldwideHotelsAndResortsAtAmazingWholesaleRates: "hôtels et centres de villégiature du monde entier à des prix de gros incroyables", // translated
  dashboard: "Tableau de bord", // translated
  pricing: "Tarification", // translated
  refundable: "Remboursable", // translated
  cars: "Voitures", // translated
  cruises: "Croisières", // translated
  view: "Voir", // translated
  price: "Prix", // translated
  guestInformationValidation: "Validation des informations client", // translated
  reservation: "Réservation", // translated
  checkIn: "Enregistrement", // translated
  checkOut: "Vérifier", // translated
  paymentInitiattionErroeMessage: "Nous n'avons pas pu lancer votre processus de paiement. Nous sommes désolés du dérangement", // translated
  warning: "Avertissement", // translated
  couldNotFindPriceForDateWarning: "Nous n'avons pas trouvé de prix pour cette date. Veuillez réessayer pour une autre date", // translated
  searchFormValidationError: "Erreur de validation du formulaire de recherche", // translated
  pleaseSelectValidDateFirst: "Veuillez d'abord sélectionner une date valide", // translated
  searchError: "Erreur de recherche", // translated
  priceSearchInitiationError: "Nous n'avons pas pu lancer le processus de recherche de prix. Veuillez réessayer plus tard. Nous sommes désolés du dérangement", // translated
  searchWarning: "Avertissement de recherche", // translated
  couldNotFindPriceAndOrAvailability: "Nous n'avons pas trouvé de prix et/ou de disponibilité pour votre demande. Nous sommes désolés du dérangement", // translated
  joinNow: "Adhérer maintenant", // translated
  signIn: "S'identifier", // translated
  searchNow: "Rechercher maintenant", // translated
  bookingFailed: "La réservation a échoué", // translated
  sorryForTheInconvenience: "Nous sommes désolés du dérangement", // translated
  paymentFailedTryAgain: "Paiement échoué. Veuillez réessayer", // translated
  quickLinks: "Liens rapides", // translated
  tours: "Visites", // translated
  termsAndConditions: "Termes et conditions", // translated
  pleaseWaitWhileInitiatingPayment: "Veuillez patienter pendant que nous lançons votre processus de paiement", // translated
  back: "Arrière", // translated
  nextStep: "L'étape suivante", // translated
  book: "Livre", // translated
  checkout: "Vérifier", // translated
  specifyPickUpPoint: "Spécifiez le point de votre ramassage préféré", // translated
  pickupPoint: "Point de ramassage", // translated
  optional: "optionnel", // translated
  remarks: "Remarques", // translated
  travellerInformation: "Informations voyageurs", // translated
  bookingRemarks: "Remarques de réservation", // translated
  bookingOverview: "Aperçu de la réservation", // translated
  paymentFailed: "Paiement échoué", // translated
  paymentSuccess: "Succès du paiement", // translated
  at: "À", // translated
  person: "personne", // translated
  cancellationPolicy: "Politique d'annulation", // translated
  From: "Depuis", // translated
  to: "pour", // translated
  cancellationIs: "l'annulation est", // translated
  pickup: "Ramasser", // translated
  flights: "Vols", // translated
  Accommodation: "Logement", // translated
  payAndBook: "Payer et réserver", // translated
  onRequest: "Sur demande", // translated
  weAreFindingTheBestAvailableServices: "Nous recherchons les meilleurs services disponibles", // translated
  withTheBestAvailablePrices: "avec les meilleurs prix disponibles", // translated
  inRealTime: "en temps réel", // translated
  seconds: "secondes", // translated
  thisProcessCanTakeUpToOneMinute: "Ce processus peut prendre jusqu'à 1 minute", // translated
  pleaseDoNotRefreshThisPage: "Merci de ne pas actualiser cette page", // translated
  wellItSeemsItCanTakeBitLonger: "Eh bien... il semble que cela puisse prendre un peu plus de temps", // translated
  yourBrowserDoesNotSupportTheVideoTag: "Votre navigateur ne prend pas en charge la balise vidéo", // translated
  bookingSuccess: "Réussite de la réservation", // translated
  bookingReference: "Référence de réservation", // translated
  referenceCopied: "Référence copiée", // translated
  shortlyYouReceiveEmailContainingInformationForYourReservation: "Vous recevrez sous peu un e-mail contenant toutes les informations nécessaires à votre réservation", // translated
  viewMore: "Voir plus", // translated
  readMore: "Lire la suite", // translated
  customerSupport: "Service client", // translated
  socialMedia: "Des médias sociaux", // translated
  get: "Avoir", // translated
  totalPrice: "Prix total", // translated
  filterRoomName: "Filtrer le nom de la salle", // translated
  clickHere: "Cliquez ici", // translated
  cancelled: "Annulé", // translated
  hours: "heures", // translated
  postalCodeIsRequired: "Le code postal est requis", // translated
  memberId: "ID membres", // translated
  firstNameMustContainAlphabetic: "Le prénom doit contenir uniquement des caractères alphabétiques", // translated
  genderIsRequired: "Le sexe est requis", // translated
  leadGuest: "Invité principal", // translated
  addressIsRequired: "L'adresse est requise", // translated
  noOptionsForSelectedFilters: "Aucune option disponible pour faire correspondre vos filtres", // translated
  active: "Actif", // translated
  sendVoucherEmail: "Envoyer un e-mail de bon d'achat", // translated
  status: "Statut", // translated
  clearYourFilters: "Veuillez effacer vos options de filtre pour afficher les résultats", // translated
  stars: "Étoiles", // translated
  privacyPolicy: "politique de confidentialité", // translated
  visitSite: "Visitez le site", // translated
  progressAt: "Des progrès à", // translated
  lastNameIsRequired: "Le nom de famille est obligatoire", // translated
  security: "Sécurité", // translated
  found: "Trouvé", // translated
  distanceFromSelection: "Distance de la sélection", // translated
  score: "Score", // translated
  star: "Étoile", // translated
  sendCancellationEmail: "Envoyer un e-mail d'annulation", // translated
  nearby: "Proche", // translated
  invalidEmail: "Email invalide", // translated
  cityIsRequired: "La ville est obligatoire", // translated
  hour: "heure", // translated
  lastNameMustContainAlphabetic: "Le nom de famille doit contenir uniquement des caractères alphabétiques", // translated
  proceed: "Procéder", // translated
  sendUsEmail: "Envoyez-nous un e-mail", // translated
  restaurants: "Restaurants", // translated
  yourReservationIsInProgress: "Votre réservation est en cours", // translated
  sendUsRequest: "Envoyez-nous votre demande", // translated
  applicationAvailable: "application disponible", // translated
  noReservationsForThisProduct: "Aucune réserve pour ce produit", // translated
  pending: "En attente", // translated
  downloadVoucher: "Télécharger le bon", // translated
  sendUsYourRequest: "Envoyez-nous votre demande", // translated
  notAvailable: "Pas disponible", // translated
  errorContentUnavailable: "Oups ! Le contenu que vous recherchez n'existe pas. Veuillez nous contacter au sujet du problème", // translated
  clearAllFilters: "Supprimer tous les filtres", // translated
  titleIsRequired: "Le titre est requis", // translated
  km: "kilomètres", // translated
  emailNotSentTryAgain: "E-mail non envoyé ! Veuillez réessayer", // translated
  iHaveReadAgreeWithAbove: "J'ai lu et je suis d'accord avec ce qui précède", // translated
  firstNameIsRequired: "Le prénom est requis", // translated
  reference: "Référence", // translated
  emailIsRequired: "L'e-mail est requis", // translated
  pleaseCheckTheBox: "Veuillez cocher la case pour indiquer que vous avez lu et accepté les informations fournies avant de passer à l'étape suivante.", // translated
  phoneNumberInTheFormat: "Le numéro de téléphone doit être au format sans espaces", // translated
  countryIsRequired: "Le pays est requis", // translated
  confirmed: "Confirmé", // translated
  currency: "Devise", // translated
  minutes: "minutes", // translated
  minute: "minute", // translated
  emailHasBeenSent: "E-mail envoyé avec succès", // translated
  phoneNumberIsRequired: "Le numéro de téléphone est requis", // translated
};

export default commonAndMisc;
